import { useFlagEnabledWithOverrides } from 'hooks/useFlagEnabledWithOverrides';
import React, { startTransition, useCallback, useMemo, useState } from 'react';
import { makePath } from 'utils/routes';
import { useLocation } from 'wouter';

import {
  type WorkspaceSettingsTabsType,
  WorkspaceSettingsModal,
} from '../pages/SchemasV2/WorkspaceSettings/WorkspaceSettingsModal';
import { NavButton } from './NavButton';
import { type NavTree, SideNav } from './SideNav';

type PaymentsNavProps = {
  workspaceId: string;
};

export const PaymentsNav = ({ workspaceId }: PaymentsNavProps) => {
  const [location] = useLocation();
  const isPaymentsForRealEnabled = useFlagEnabledWithOverrides(
    'dashboard-payments-for-real'
  );
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [settingsTab, setSettingsTab] =
    useState<WorkspaceSettingsTabsType>('workspace');

  const handleCloseSettings = useCallback(
    () => startTransition(() => setIsSettingsOpen(false)),
    []
  );
  const handleOpenSettings = useCallback(
    () => startTransition(() => setIsSettingsOpen(true)),
    []
  );

  const navTree: NavTree = useMemo(
    () => ({
      // home: {
      //   props: {
      //     href: makePath(['w', workspaceId, 'payments']),
      //     children: 'Home',
      //     active: /\/payments\/?$/.test(location),
      //   },
      // },
      invoices: {
        props: {
          href: makePath(['w', workspaceId, 'payments', 'invoices']),
          children: 'Invoices',
          active: location.includes('/invoices'),
        },
      },
      reconciliation: {
        props: {
          href: makePath(['w', workspaceId, 'payments', 'transactions']),
          children: 'Recon',
          active: location.includes('/transactions'),
        },
      },
      catalog: {
        props: {
          href: makePath(['w', workspaceId, 'payments', 'catalog']),
          children: 'Catalog',
          active: location.includes('/catalog'),
        },
      },
      users: {
        props: {
          href: makePath(['w', workspaceId, 'payments', 'users']),
          children: 'Users',
          active: location.includes('/users'),
        },
      },
      ...(isPaymentsForRealEnabled
        ? {
            payments: {
              props: {
                href: makePath([
                  'w',
                  workspaceId,
                  'payments',
                  'payment-settings',
                ]),
                children: 'Payments',
                active: location.includes('/payment-settings'),
              },
            },
          }
        : {}),
    }),
    [workspaceId, location, isPaymentsForRealEnabled]
  );

  return (
    <div
      className="flex flex-col text-xmd font-helvetica"
      data-testid="payments-nav"
    >
      <SideNav
        listStyle="unordered"
        navTree={navTree}
        depth={0}
        showMarkers={false}
        fontFamily="font-helvetica"
      />
      <NavButton
        onClick={() => {
          setSettingsTab('workspace');
          handleOpenSettings();
        }}
        marker="bullet"
        showMarker={false}
        label="Settings"
        isActive={isSettingsOpen}
        testId="payments-nav-settings-button"
      />
      {isSettingsOpen && (
        <WorkspaceSettingsModal
          handleClose={handleCloseSettings}
          defaultTab={settingsTab}
        />
      )}
    </div>
  );
};
